import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import PropTypes from 'prop-types'
import { Spinner } from 'baseui/spinner'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import { useTranslation } from 'react-i18next'
import ForceFieldButton from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/ForceFieldButton'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'
import useEmail from './useEmail'
import EmailSuggestion from './EmailSuggestion'

const Email = ({
  caption,
  captionForceEmail,
  currentValue,
  error,
  isLoading,
  mandatory,
  removeErrors,
  updateNeverBounce,
  verifyEmail,
  disabled,
  neverBounceResult,
}) => {
  const { t } = useTranslation()
  const { emailSuggestion, status, onBlur, onAcceptSuggestion, clearEmailSuggestion, forceAddress } = useEmail({
    verifyEmail,
    captionForceEmail,
    updateNeverBounce,
    removeErrors,
    neverBounceResult,
  })

  const enhancer = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {isLoading && <Spinner size='18px' />}
      <CopyEndEnhancer value={currentValue} />
    </div>
  )

  return (
    <>
      <SDFormControl plainLabel error={error} caption={caption}>
        <SDInput
          label={mandatory + t('subscriptionForm:customer_module.email.label')}
          id='customer-input-email'
          disabled={disabled}
          currentValue={currentValue}
          error={error}
          endEnhancer={enhancer}
          onBlur={onBlur}
          outerOnchange={clearEmailSuggestion}
          status={status}
        />
      </SDFormControl>
      <EmailSuggestion suggestion={emailSuggestion} onAccept={onAcceptSuggestion} />
      <ForceFieldButton
        hidden={!error}
        onForce={forceAddress}
        label={t('subscriptionForm:customer_module.email.forceLabel')}
        buttonText={t('subscriptionForm:customer_module.email.forceButton')}
      />
    </>
  )
}

Email.propTypes = {
  caption: PropTypes.string,
  captionForceEmail: PropTypes.func,
  currentValue: PropTypes.string,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  mandatory: PropTypes.string,
  removeErrors: PropTypes.func,
  updateNeverBounce: PropTypes.func,
  verifyEmail: PropTypes.func,
  disabled: PropTypes.bool,
  neverBounceResult: PropTypes.string,
}

export default Email
